import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Container, Box, Paper } from '@mui/material';
import CustomButton from '../../components/buttons/CustomButton';
import styles from './Welcome.module.css';
import AreaTitle from '../../components/areaTitle/AreaTitle';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Feature Card Component
const FeatureCard = ({ icon, title, description }) => (
  <Paper elevation={0} className={styles.featureCard}>
    <div className={styles.featureIcon}>{icon}</div>
    <div className={styles.featureContent}>
      <Typography variant="subtitle2" className={styles.featureTitle}>
        {title}
      </Typography>
      <Typography variant="body2" className={styles.featureDescription}>
        {description}
      </Typography>
    </div>
  </Paper>
);

function Welcome() {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate('/dashboard');
  };

  return (
    <Container className={styles.container}>
      <Box className={styles.content}>
        <Typography variant="h4" className={styles.title}>
          Boas-vindas à Gabriela!
        </Typography>
        <Typography variant="body1" className={styles.message}>
          Estamos muito felizes em ter você conosco! O Gabriela é uma plataforma completa
          que vai transformar a maneira como você gerencia seu negócio, tornando tudo mais simples e eficiente.
        </Typography>
        
        <div className={styles.mainContent}>
          <div className={styles.featureSection}>
            <AreaTitle
              Title="Descubra o que podemos fazer por você"
              Icon={<ExploreOutlinedIcon />}
              Description="Nossa plataforma foi desenvolvida para facilitar sua gestão diária e proporcionar uma experiência completa tanto para você quanto para seus clientes."
            />
            
            <div className={styles.featureGrid}>
              <FeatureCard
                icon={<CalendarMonthOutlinedIcon fontSize="small" />}
                title="Agenda Inteligente"
                description="Organize seus compromissos com facilidade e evite conflitos de horários"
              />
              <FeatureCard
                icon={<PeopleOutlinedIcon fontSize="small" />}
                title="Gestão de Clientes"
                description="Mantenha todos os dados e histórico de seus clientes organizados"
              />
              <FeatureCard
                icon={<NotificationsActiveOutlinedIcon fontSize="small" />}
                title="Confirmações e lembretes"
                description="Reduza faltas com confirmações e lembretes prontos para enviar pelo WhatsApp"
              />
              <FeatureCard
                icon={<PaymentsOutlinedIcon fontSize="small" />}
                title="Controle Financeiro"
                description="Acompanhe pagamentos, receitas e despesas em um só lugar"
              />
              <FeatureCard
                icon={<AnalyticsOutlinedIcon fontSize="small" />}
                title="Relatórios e Análises"
                description="Visualize o desempenho do seu negócio com relatórios detalhados"
              />
              <FeatureCard
                icon={<ScheduleOutlinedIcon fontSize="small" />}
                title="Lista de Espera"
                description="Gerencie cancelamentos e encaixes de forma eficiente"
              />
            </div>
            
            <div className={styles.startButtonContainer}>
              <CustomButton
                variant="contained"
                style="secondary"
                label="Começar Agora"
                onClick={handleStart}
                icon={<ArrowForwardIcon />}
              />
            </div>
          </div>
        </div>
      </Box>
    </Container>
  );
}

export default Welcome;